import type { OrganizationWorkingHours } from '@kanbu/schema';
import { isWithinHours } from '@kanbu/shared';
import { createContext, useContext } from 'react';

export const WorkingHoursContext =
  createContext<OrganizationWorkingHours | null>(null);

export function useWorkingHours() {
  const workingHours = useContext(WorkingHoursContext);

  return { workingHours, isOpen: isWithinHours(workingHours) };
}
